import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Image from 'gatsby-image';
import LetsChat from './lets-chat';
import FooterMenu from '../menus/footer-menu';
import SocialMenu from '../menus/social-menu';
import InfoMenu from '../menus/info-menu';
import CopyWrite from './copy-write';
import styles from './footer.module.css';

const Footer = ({
  footerMenuItems,
  socialMenuItems,
  infoMenuItems,
  currentPage,
  awards,
}) => {
  const renderAwards = () => {
    return awards.map((award, index) => {
      return (
        <Link to={`${award.footer_award_link}`} key={index} className={styles.award}>
          <Image
            className={styles.awardImage}
            outerWrapperClassName={styles.imageOuterWrapper}
            sizes={award.footer_award_image.localFile.childImageSharp.sizes}
            backgroundColor={true}
            alt="jkdesign award"
          />
        </Link>
      );
    });
  };

  return (
    <React.Fragment>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.awards}>{renderAwards()}</div>
          <div className={styles.navigation}>
            <div className={styles.info}>
              <LetsChat />
              <FooterMenu footerMenuItems={footerMenuItems} />
              <InfoMenu infoMenuItems={infoMenuItems} />
              <CopyWrite />
              <SocialMenu socialMenuItems={socialMenuItems} />
            </div>
          </div>
        </div>
      </div>
      {currentPage === '/' && <div style={{ height: '75px', width: '100%' }} />}
    </React.Fragment>
  );
};

Footer.propTypes = {
  footerMenuItems: PropTypes.array,
  socialMenuItems: PropTypes.array,
  infoMenuItems: PropTypes.array,
  currentPage: PropTypes.string,
  awards: PropTypes.array,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js